import { Typography } from "@material-ui/core";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import useNavigator from "@saleor/hooks/useNavigator";
import React from "react";

import BreadcrumbMoreNavigation from "./BreadcrumbMoreNavigation";

interface BreadcrumbItem {
  name: string;
  url?: string;
}

interface PageBreadcrumbNavigationProps {
  items: BreadcrumbItem[];
  confirmationLink?: boolean;
  toggleCancelDialog?: () => void;
  onClickCallback?: (url: string) => void;
}

const PageBreadcrumbNavigation: React.FC<PageBreadcrumbNavigationProps> = props => {
  const { items, onClickCallback } = props;

  const allItems = [{ name: "Home", url: "/" }, ...items];
  const shouldCollapse = allItems.length > 3;
  const visibleItems = shouldCollapse ? allItems.slice(-3) : allItems;
  const collapsedItems = shouldCollapse ? allItems.slice(0, -3) : [];
  const actionItems = collapsedItems.map(item => ({
    id: item.name.replace(/\s+/g, ""),
    label: item.name,
    url: item.url ?? "#"
  }));

  return (
    <div>
      <Breadcrumbs aria-label="breadcrumb">
        {shouldCollapse && (
          <BreadcrumbMoreNavigation
            id={"breadcrumbMoreNavigation"}
            items={actionItems}
          />
        )}

        {visibleItems.map((item, index) => (
          <PageBreadcrumb
            name={item.name}
            url={item.url}
            key={index}
            onClickCallback={onClickCallback}
          />
        ))}
      </Breadcrumbs>
    </div>
  );
};

const PageBreadcrumb = ({ name, url, onClickCallback }) => {
  const navigate = useNavigator();
  const handleNavigate = () => {
    if (onClickCallback !== undefined) {
      onClickCallback(url);
    } else {
      navigate(url);
    }
  };

  if (url === undefined || url == null) {
    return <Typography style={{ fontWeight: "bold" }}>{name}</Typography>;
  } else {
    return (
      <Link>
        <Typography
          style={{ color: "#247CFF", cursor: "pointer" }}
          onClick={handleNavigate}
        >
          {name}
        </Typography>
      </Link>
    );
  }
};

export default PageBreadcrumbNavigation;
